"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestLetterSchema = void 0;
var constants_1 = require("@hobt/constants");
var detail_1 = require("../detail");
var constants_2 = require("../../constants");
exports.requestLetterSchema = {
    type: 'object',
    required: [
        'createdDate',
        'detail',
        'finalizedDate',
        'languageCode',
        'reasonCode',
        'requestedAmount',
        'sentFlag',
    ],
    properties: {
        accountsReceivableInvoiceNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 13,
            errorMessage: 'should have maximum length of 13 characters',
        },
        createdDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
        },
        detail: detail_1.detailSchema,
        finalizedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
        },
        languageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should be a valid Language Enum value',
        },
        reasonCode: {
            type: 'number',
            enum: Object.values(constants_2.RefundReason),
            errorMessage: 'Should be a valid Reason Enum value',
        },
        requestedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        sentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
        },
        sentFlag: {
            type: 'boolean',
            errorMessage: 'should be true or false',
        },
    },
};
